import { Children, Fragment, type ReactNode, isValidElement } from 'react';

/**
 * Robustly checks if a ReactNode is considered "empty" for rendering purposes.
 * Handles null, undefined, empty strings, empty arrays, and empty Fragments.
 *
 * @param {ReactNode} node - The React node to check for emptiness.
 * @returns {boolean} True if the node is empty and should not render content.
 */
export const isEmptyReactNode = (node: ReactNode): boolean => {
  if (node === null || node === undefined || node === false) {
    return true;
  }

  if (typeof node === 'string' && node.trim() === '') {
    return true;
  }

  if (Array.isArray(node)) {
    return Children.count(node) === 0;
  }

  if (isValidElement(node) && node.type === Fragment) {
    return Children.count(node.props.children) === 0;
  }

  return false;
};
